import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { setEntitlementRequiredHandler } from '@/services/http'
import { useWarungStore } from '@/stores/warung'
import './styles/main.css'
import './styles/warung-workspace.css'
import './styles/auth.css'
import './styles/auth-viewport-fix.css'
import './styles/auth-google-modal.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

setEntitlementRequiredHandler((entitlement) => {
  if (entitlement !== 'web_access') return

  // API adalah sumber kebenaran. Jika paket berubah ketika Owner masih diam di
  // halaman operasional, request pertama yang ditolak akan menyegarkan paket
  // lalu memindahkan UI ke halaman Paket tanpa mengandalkan parsing pesan 403.
  const store = useWarungStore(pinia)
  void store.loadSubscription().catch(() => undefined).finally(() => {
    if (router.currentRoute.value.meta.warung === true && router.currentRoute.value.name !== 'warung-subscription') {
      void router.replace({ name: 'warung-subscription', query: { feature: 'web' } })
    }
  })
})

app.mount('#app')
